import React, { memo } from "react";
//* ReactFlow Library
import { Panel } from "reactflow";

//* Import Context API
import { useBracketState } from "../context/BracketStateContext";

const GlobalFields = () => {
  //* Context API
  const { templateInfo, setTemplateInfo } = useBracketState();

  const teamNumbers = Array.from({ length: 126 }, (_, index) => index + 3);

  // Generic function to update state
  const handleInputChange = (field, value) => {
    setTemplateInfo({ ...templateInfo, [field]: value });
  };

  return (
    <Panel position="top-left" className="globalFields">
      <div className="row">
        <div className="col-md-3">
          <select
            name="teams"
            id="teams"
            className="form-control"
            onChange={(e) => handleInputChange("teams", e.target.value)}
            value={templateInfo.teams ? templateInfo.teams : undefined}
          >
            <option value="" key="0">
              Select Teams
            </option>
            {teamNumbers.map((team) => (
              <option key={team} value={team}>
                {`${team} teams`}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4">
          <select
            name="bracket_type"
            id="bracket_type"
            className="form-control"
            onChange={(e) => handleInputChange("bracket_type", e.target.value)}
            value={
              templateInfo.bracket_type ? templateInfo.bracket_type : undefined
            }
          >
            <option value="" key="0">
              Select Bracket Type
            </option>
            <option value="single" key="single">
              Single Elimination
            </option>
            <option value="double" key="double">
              Double Elimination
            </option>
            <option value="compass" key="compass">
              Compass Draw
            </option>
          </select>
        </div>
        <div className="col-md-5">
          <input
            type="text"
            className="form-control"
            placeholder="Template Name"
            value={templateInfo.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
          />
        </div>
      </div>
    </Panel>
  );
};

export default memo(GlobalFields);
